import React, { useCallback } from 'react';
import styles from './index.module.sass';
import TextInput from 'componets/text-input';
import Button from 'componets/button';
import LoginFrame from 'layout/login-frame';
import iconInfo from 'images/icon-info.svg';
import { CHANGE_TOTP, useLoginContext } from 'features/login/use-login';
import analytics from 'service/analytics';

const TwoFAForm = () => {
  const { state, dispatch, onAuthTOTP, onLockTab } = useLoginContext();

  const onTotpChange = useCallback(
    totp => {
      dispatch({
        type: CHANGE_TOTP,
        payload: totp,
      });
    },
    [dispatch]
  );

  const onTwoFAFocus = () => {
    analytics.track('登入頁_2FA_驗證碼_click');
    onLockTab();
  };

  const onAuthTOTPClick = () => {
    analytics.track('登入頁_2FA_送出_click');
    onAuthTOTP();
  };

  return (
    <LoginFrame>
      <div className={styles.title}>兩步驟驗證</div>
      <div className={styles.form}>
        <TextInput
          label="從 Google Authenticator 應用程式取得驗證碼"
          maxLength={6}
          digits="[0-9]"
          errorMessage={state.totpErrorMessage}
          value={state.totp}
          onTextChange={onTotpChange}
          placeholder="輸入驗證碼"
          onKeyPressEnter={onAuthTOTPClick}
          onFocus={onTwoFAFocus}
        />
        <div className={styles.hint}>
          <img src={iconInfo} alt="info" />
          若遇到問題請聯繫客服
        </div>
      </div>
      <Button
        variant="default"
        size="full-width"
        className={styles['login-button']}
        onClick={onAuthTOTPClick}
        loading={state.loading}
      >
        登入
      </Button>
    </LoginFrame>
  );
};

export default TwoFAForm;
